module.exports = __webpack_public_path__ + "img/no-candidate-in-this-status.13d4a5ea.svg";